import { WORKFLOW_STATE_LABEL } from '../../../core/constants/domain';

// Core has no progress endpoint; progress is derived from the task list
// (done over everything not discarded). Documented as a draft limitation.
const SEGMENTS = [
    { key: 'done', states: ['done'], tone: 'ok' },
    { key: 'in_review', states: ['in_review'], tone: 'waiting' },
    { key: 'claimed', states: ['claimed'], tone: 'running' },
    { key: 'pending', states: ['ready', 'proposed', 'returned'], tone: 'idle' },
    { key: 'blocked', states: ['blocked'], tone: 'blocked' },
];

const SEGMENT_LABEL = {
    done: WORKFLOW_STATE_LABEL.done,
    in_review: WORKFLOW_STATE_LABEL.in_review,
    claimed: WORKFLOW_STATE_LABEL.claimed,
    pending: 'Pendientes',
    blocked: WORKFLOW_STATE_LABEL.blocked,
};

export function summarizeProgress(tasks) {
    const counted = tasks.filter((task) => task.state !== 'discarded');
    const segments = SEGMENTS.map((segment) => ({
        key: segment.key,
        label: SEGMENT_LABEL[segment.key],
        tone: segment.tone,
        value: counted.filter((task) => segment.states.includes(task.state)).length,
    }));
    const done = segments.find((segment) => segment.key === 'done').value;
    return {
        total: counted.length,
        done,
        percent: counted.length ? Math.round((done / counted.length) * 100) : 0,
        segments,
    };
}

export function groupByTier(tasks) {
    const groups = new Map();
    for (const task of tasks) {
        if (!groups.has(task.tierId)) groups.set(task.tierId, []);
        groups.get(task.tierId).push(task);
    }
    return groups;
}
